import { Component, Input } from '@angular/core';
import { Leg } from '@ridango/components';

@Component({
    selector: 'rwidget-leg-wait',
    templateUrl: './leg-wait.component.html',
})
export class LegWaitComponent {
    @Input() leg: Leg;
}
